import {styledByTheme} from "../../../../themes/architecture/styled-by-theme";
import {JackpotBetWidgetGradientTextDefaultBox} from "./jackpot-bet-widget-gradient-text.default.box";
import {JackpotBetWidgetGradientTextMRGBox} from "./jackpot-bet-widget-gradient-text.mrgreen.box";
import {JackpotBetWidgetGradientText777Box} from "./jackpot-bet-widget-gradient-text.777.box";


export const JackpotBetWidgetGradientTextBox = styledByTheme(JackpotBetWidgetGradientTextDefaultBox)
    .forMrGreen(JackpotBetWidgetGradientTextMRGBox)
    .forCasino777(JackpotBetWidgetGradientText777Box)
    .apply();